/** @jsx jsx */
import { jsx } from 'theme-ui';
import { NO_TIME, SlotPicker } from './SlotPicker';
import 'dayjs/plugin/timezone';
import { dayjs } from '../util/dayjs';
import { Card } from './Card';
import { Clickable } from './Clickable';
export var SlotField = function (_a) {
    var value = _a.value, onChange = _a.onChange, pharmacyId = _a.pharmacyId, appointmentTypeId = _a.appointmentTypeId, error = _a.error;
    var noTimeSelected = !value || value.endsWith(NO_TIME);
    var borderColor = error ? 'danger' : 'grey';
    return !noTimeSelected ? (jsx(Card, { sx: { p: 2, borderColor: borderColor }, as: Clickable, onClick: function () {
            onChange(value.substring(0, 10) + 'T' + NO_TIME);
        } },
        jsx("div", { sx: { fontWeight: 'bold', color: 'secondary' } }, value.substring(11, 16)),
        jsx("div", null, dayjs(value.substring(0, 10)).format('dddd, Do of MMMM YYYY')))) : (jsx(Card, { sx: { p: 2, borderColor: borderColor } },
        jsx(SlotPicker, { pharmacyId: pharmacyId, appointmentTypeId: appointmentTypeId, value: dayjs(value), onChange: function (value) {
                onChange(value.format('YYYY-MM-DD[T]HH:mm'));
            } })));
};
//# sourceMappingURL=SlotField.js.map